import React from "react";
import Mission from "./Mission";
import OurPosition from "./OurPosition";
import OurTeam from "./OurTeam";
import Story from "./Story";
import SuccessStory from "./SuccessStory";
import "../../../App.css";
import Newsletter from "../../shared/Newsletter";
import Footer from "../../shared/Footer";
const Company = () => {
  return (
    <div className="px-10">
      <Mission />
      <Story />
      <SuccessStory />
      <OurTeam />
      <OurPosition />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Company;
